import { getClientId } from './client-id';
import { registerNeuronDeckServiceWorker } from './pwa';
export async function taskApi<T>(path = '', init: RequestInit = {}): Promise<T> {
  const response = await fetch(`/api/tasks${path}`, { ...init, headers: { 'content-type': 'application/json', 'x-neurondeck-client': getClientId(), ...init.headers }, cache: 'no-store' });
  const result = await response.json().catch(() => ({})) as { error?: { code?: string } };
  if (!response.ok) throw new Error(result.error?.code || 'task_request_failed');
  return result as T;
}
export async function enableTaskPush(publicKey: string): Promise<void> {
  if (!('Notification' in window) || !('PushManager' in window) || !('serviceWorker' in navigator)) throw new Error('push_unsupported');
  // Ask synchronously in the explicit click, before any fetch/register operation.
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('push_permission');
  const registration = await registerNeuronDeckServiceWorker();
  if (!registration) throw new Error('push_unsupported');
  await navigator.serviceWorker.ready;
  const key = Uint8Array.from(atob(publicKey.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0));
  const subscription = await registration.pushManager.getSubscription() ?? await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  await taskApi('/push', { method: 'POST', body: JSON.stringify(subscription.toJSON()) });
}
export async function disableTaskPush(): Promise<void> {
  await taskApi('/push', { method: 'DELETE' });
  const registration = await navigator.serviceWorker?.getRegistration();
  await (await registration?.pushManager.getSubscription())?.unsubscribe();
}
